import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set')({
  beforeLoad: () => getTitleContextSlice('Rule Sets'),
  staticData: {
    owner: CodeOwner.Uvm,
  },
});
